module.exports = __webpack_public_path__ + "img/angle_15.58a39e43.jpg";